import { GT2CalendarUtils } from './../../../utils/GT2CalendarUtils';
import { EnterpriseInvoiceService } from './../EnterpriseInvoice.service';
import { CountryContextService } from './../../../services/country-context.service';
import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { EnterpriseCashingPanelService } from '../../../services/enterprise-cashing-panel.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DeliveryRequestContentService } from '../../../api/delivery-request-content.service';
import { DeliveryRequestTypeService } from '../../../api/delivery-request-type.service';
import { DepositInService } from '../../../api/deposit-in.service';
import { DepositRequestService } from '../../../api/deposit-request.service';
import { PaymentModesService } from '../../../api/payment-modes.service';
import { WrappingService } from '../../../api/wrapping.service';
import { ValidatorHelper } from '../../../validators/ValidatorHelper';
import { NGXLogger } from 'ngx-logger';
import { ToastrService } from 'ngx-toastr';
import { FuseTranslationLoaderService } from '../../../../../@fuse/services/translation-loader.service';
import { GT2PageAbstract } from '../../../content/abstract/GT2PageAbstract';
import { Settings } from '../../../settings/settings';
import { locale as english } from './../../clients/i18n/en-CA';
import { locale as french } from './../../clients/i18n/fr-CA';
import { GT2DateAdapter } from '../../../utils/GT2DateAdapter';
import { DatatableHelperService } from '../../../../services/datatable-helper.service';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Gt2SelectComponent } from '../../../components/gt2-select/gt2-select.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { EnterpriseCashingInvoiceComponent } from '../enterprise-cashing-invoice/enterprise-cashing-invoice.component';
import { MatButtonModule } from '@angular/material/button';
import { EditorModule } from 'primeng/editor';
import { ViewHtmlButtonDirective } from '../../../directives/view-html-button.directive';
import { EmojiPickerButtonComponent } from '../../../components/emoji-picker-button/emoji-picker-button.component';
import { CalendarDateFormatter } from 'angular-calendar';
import { CustomDateFormatter } from '../../calendar/CustomDateFormatter';
import moment from 'moment';

@Component({
  selector: 'app-enterprise-cashing-modal',
  templateUrl: './enterprise-cashing-modal.component.html',
  styleUrls: ['./enterprise-cashing-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MatInputModule,
    EnterpriseCashingInvoiceComponent,
    EditorModule,
    ViewHtmlButtonDirective,
    EmojiPickerButtonComponent,
    MatDatepickerModule,
    Gt2SelectComponent,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
  ],
  providers: [
    { provide: DateAdapter, useClass: GT2DateAdapter },
    { provide: CalendarDateFormatter, useClass: CustomDateFormatter },
    EnterpriseInvoiceService,
    DatatableHelperService,
  ],
  encapsulation: ViewEncapsulation.None,
})
export class EnterpriseCashingModalComponent
  extends GT2PageAbstract
  implements OnInit, AfterViewInit, OnDestroy
{
  parentUUID?: any;
  form: UntypedFormGroup;
  formRef: UntypedFormGroup;
  //
  depositIn: any;
  /** Texte du champ Montant tel que saisi (séparateur , ou . conservé). */
  amountInput: string = '';
  //
  invoices!: any[];
  invoicesModel!: any[];
  totalEntered: number = 0;
  totalEnteredRounded: number = 0;
  //
  noteInvalid: boolean = false;
  //
  override loading: boolean = false;
  //
  constructor(
    private panelService: EnterpriseCashingPanelService,
    private translationLoader: FuseTranslationLoaderService,
    public translate: TranslateService,
    private formBuilder: UntypedFormBuilder,
    public deliveryRequestTypeService: DeliveryRequestTypeService,
    public deliveryRequestContentService: DeliveryRequestContentService,
    public wrappingService: WrappingService,
    public depositRequestService: DepositRequestService,
    public paymentModesService: PaymentModesService,
    private depositInService: DepositInService,
    public dialog: MatDialog,
    public router: Router,
    private adapter: DateAdapter<any>,
    private toastr: ToastrService,
    private logger: NGXLogger,
    private enterpriseInvoiceService: EnterpriseInvoiceService,
    public countryContext: CountryContextService,
  ) {
    super();
    this.translationLoader.loadTranslations(english, french);
    this.adapter.setLocale(this.translate.currentLang);
    //
    this.form = this.formBuilder.group({
      // cashing_amount: ["", [Validators.required]],
      received_at: ['', [ValidatorHelper.dateTodaysOrLower]],
      amount: ['', [Validators.required]],
    });
    //
    // Numéro de référence facultatif (comme en GT2) — longueur validée
    // seulement si rempli.
    this.formRef = this.formBuilder.group({
      ref_number: [
        '',
        [
          Validators.minLength(Settings.inputMinChar),
          Validators.maxLength(Settings.inputMaxCharMid),
        ],
      ],
    });
    //
    this.depositIn = {
      // received_at: new Date().toISOString(),
      received_at: moment().format('YYYY-MM-DD'),
      amount: null,
      ref_number: null,
      note: null,
      payment_mode: null,
    };
    //
    const data = this.panelService.getData();

    if (data?.parentUUID) {
      this.parentUUID = data.parentUUID;
    }
    if (data?.cashing_amount) {
      this.depositIn.amount = data.cashing_amount;
      this.amountInput = Number(data.cashing_amount).toFixed(2);
    }
    if (data?.invoices) {
      this.invoices = data.invoices;
      this.crunchData();
      // if (this.depositIn.amount) {
      //     this.crunchData();
      // }
    }
    // //this.logger.info(
    //     "EnterpriseCashingModalComponent invoices: " +
    //         JSON.stringify(this.invoices)
    // );
  }

  ngOnInit(): void {
    this.applyDefaultPaymentMode();
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {}

  /**
   * Pre-select the payment mode flagged as default in the preferences
   * (payment_modes.is_default). Never overrides an existing selection.
   */
  private applyDefaultPaymentMode(): void {
    if (this.depositIn.payment_mode) {
      return;
    }

    this.paymentModesService.getPaymentModesList().subscribe({
      next: (response: any) => {
        const list: any[] = response?.data ?? [];
        const defaultMode = list.find((pm) => pm.is_default);
        if (defaultMode && !this.depositIn.payment_mode) {
          this.onPaymentModeChange(defaultMode);
        }
      },
      error: (error: any) => {
        this.logger.error(
          'EnterpriseCashingModalComponent.applyDefaultPaymentMode() -> ERROR: ' +
            JSON.stringify(error),
        );
      },
    });
  }

  public crunchData(): void {
    this.invoicesModel = [];
    let amount = this.depositIn.amount;
    if (!amount) {
      // amount = 0;
      this.crunchNoAmount();
    } else {
      this.crunchAmount(amount);
    }
    //
    this.crunchTotal();
  }

  public gtRound(num: number): number {
    return Math.round((num + Number.EPSILON) * 100) / 100;
    // Math.round((num + Number.EPSILON) * 100) / 100;
  }

  public crunchAmount(amount: number): void {
    // const formatter = new Intl.NumberFormat("en-US", {
    //     minimumFractionDigits: 2,
    //     maximumFractionDigits: 2,
    // });
    // TODO: get rid of all toFixed(2) and create a custom round method instead
    for (const invoice in this.invoices) {
      // La distribution se fait sur la BALANCE (reste à payer), pas sur le
      // total de la facture — une facture presque payée ne doit recevoir
      // que ce qui lui manque.
      const invoiceTotal: number = parseFloat(
        this.invoices[invoice].event.balance,
      );
      let newAmount: number = amount - invoiceTotal;
      amount = newAmount;
      let finalAmount: number = 0;
      if (amount < 0) {
        // Argent épuisé : plancher à 0 — jamais de montant négatif (le
        // backend les accepte sans valider et fausse les balances).
        finalAmount = Math.max(0, this.gtRound(invoiceTotal + amount));
      } else {
        finalAmount = this.gtRound(invoiceTotal);
      }
      this.invoicesModel?.push({
        amount: finalAmount,
        received_at: GT2CalendarUtils.formatDateForAPI(
          this.depositIn.received_at,
        ),
        // received_at: this.depositIn.received_at,
        ref_number: this.depositIn.ref_number,
        note: this.depositIn.note,
        payment_mode: this.depositIn.payment_mode,
        invoice: this.invoices[invoice],
      });
    }
  }

  // public crunchAmount(amount: number): void {
  //     // const formatter = new Intl.NumberFormat("en-US", {
  //     //     minimumFractionDigits: 2,
  //     //     maximumFractionDigits: 2,
  //     // });
  //     // TODO: get rid of all toFixed(2) and create a custom round method instead
  //     for (const invoice in this.invoices) {
  //         const invoiceTotal: number = parseFloat(
  //             this.invoices[invoice].event.stats.total_raw
  //         );
  //         let newAmount: number = amount - invoiceTotal;
  //         amount = newAmount;
  //         let finalAmount: number = 0;
  //         if (amount < 0) {
  //             finalAmount = parseFloat((invoiceTotal + amount).toFixed(2));
  //         } else {
  //             finalAmount = parseFloat(invoiceTotal.toFixed(2));
  //         }
  //         this.invoicesModel.push({
  //             amount: finalAmount,
  //             received_at: GT2CalendarUtils.formatDateForAPI(
  //                 this.depositIn.received_at
  //             ),
  //             // received_at: this.depositIn.received_at,
  //             ref_number: this.depositIn.ref_number,
  //             note: this.depositIn.note,
  //             payment_mode: this.depositIn.payment_mode,
  //             invoice: this.invoices[invoice],
  //         });
  //     }
  // }

  public crunchNoAmount(): void {
    for (const invoice in this.invoices) {
      this.invoicesModel?.push({
        amount: 0,
        received_at: GT2CalendarUtils.formatDateForAPI(
          this.depositIn.received_at,
        ),
        // received_at: this.depositIn.received_at,
        ref_number: this.depositIn.ref_number,
        note: this.depositIn.note,
        payment_mode: this.depositIn.payment_mode,
        invoice: this.invoices[invoice],
      });
    }
  }

  // Montant global supérieur à la somme des BALANCES (reste à payer) des
  // factures sélectionnées → sauvegarde interdite.
  get amountExceedsInvoices(): boolean {
    return (
      this.depositIn?.amount !== null &&
      this.depositIn?.amount !== undefined &&
      this.depositIn.amount > this.totalBalanceAmount + 0.001
    );
  }

  // Sommes des colonnes Total / Payé / Balance.
  get totalInvoicesTotal(): number {
    let total = 0;
    for (const item of this.invoicesModel ?? []) {
      total += parseFloat(item.invoice?.event?.stats?.total_raw ?? 0) || 0;
    }
    return this.gtRound(total);
  }

  get totalBalanceAmount(): number {
    let total = 0;
    for (const item of this.invoicesModel ?? []) {
      total += parseFloat(item.invoice?.event?.balance ?? 0) || 0;
    }
    return this.gtRound(total);
  }

  get totalPaidAmount(): number {
    return this.gtRound(this.totalInvoicesTotal - this.totalBalanceAmount);
  }

  // Balance complète restante : ce qu'il reste à encaisser après la
  // distribution (somme des balances − somme des encaissements saisis).
  get remainingBalance(): number {
    return this.gtRound(this.totalBalanceAmount - this.totalEnteredRounded);
  }

  public crunchTotal(): void {
    this.totalEntered = 0;
    this.totalEnteredRounded = 0;
    for (const item of this.invoicesModel) {
      this.totalEntered += parseFloat(item.amount);
      this.totalEnteredRounded +=
        Math.round((parseFloat(item.amount) + Number.EPSILON) * 100) / 100;
    }
    // for (const invoice in this.invoicesModel) {
    //     this.totalEntered += parseFloat(this.invoicesModel[invoice].amount);
    // }
  }

  public onCreateCashings(): void {
    this.loading = true;
    // Ne PAS redistribuer ici (crunchData) : l'utilisateur a pu ajuster
    // manuellement les montants par facture après la distribution. On
    // rafraîchit seulement les métadonnées communes sur chaque ligne.
    for (const item of this.invoicesModel ?? []) {
      item.received_at = GT2CalendarUtils.formatDateForAPI(
        this.depositIn.received_at,
      );
      item.ref_number = this.depositIn.ref_number;
      item.note = this.depositIn.note;
      item.payment_mode = this.depositIn.payment_mode;
    }
    // Garde-fou : n'envoyer que les lignes avec un montant strictement
    // positif — pas de cashings à 0 $ ni négatifs côté serveur.
    const cashingsToSend = (this.invoicesModel ?? []).filter(
      (item: any) => parseFloat(item.amount) > 0,
    );
    if (cashingsToSend.length === 0) {
      this.loading = false;
      return;
    }
    //
    //this.logger.info("EnterpriseCashingModalComponent.onCreateCashings()" + JSON.stringify(this.invoicesModel));
    this.enterpriseInvoiceService
      .createMultiCqashing(this.parentUUID, cashingsToSend)
      .subscribe({
        next: (response: any) => {
          //this.logger.info("EnterpriseCashingModalComponent.onCreateCashings() -> response:" + JSON.stringify(response));
          this.loading = false;
          this.panelService.emitResult(true);
        },
        error: (error: any) => {
          this.logger.error(
            'EnterpriseCashingModalComponent.onCreateCashings() -> ERROR:' +
              JSON.stringify(error),
          );
          this.loading = false;
        },
      });
  }

  public onPaymentModeChange(event: any): void {
    //this.logger.info("EnterpriseCashingModalComponent.onPaymentModeChange() -> event: " + JSON.stringify(event));
    this.depositIn.payment_mode = event;
  }

  public close(): void {
    this.panelService.emitResult(false);
  }

  // Le champ Montant utilise [ngModel] one-way + formControlName : il faut
  // reporter la saisie dans depositIn.amount AVANT de redistribuer, sinon la
  // distribution tourne toujours avec l'ancien montant (vide).
  // L'input est lié à amountInput (chaîne telle que tapée) et non à la valeur
  // parsée — sinon Angular réécrit « 3000,40 » en « 3000.4 » pendant la
  // frappe. Virgule et point sont acceptés ; le blur formate à 2 décimales en
  // conservant le séparateur utilisé.
  public onNewAmount(event: any): void {
    //this.logger.info("EnterpriseCashingModalComponent.onNewAmount() - amount: " + event);
    const raw = String(event ?? '');
    // Positif seulement : retirer tout caractère hors chiffres/./ , (dont -).
    const sanitized = raw.replace(/[^0-9.,]/g, '');
    if (sanitized !== raw) {
      this.form.get('amount')?.setValue(sanitized, { emitEvent: false });
    }
    this.amountInput = sanitized;
    const parsed = parseFloat(sanitized.replace(',', '.'));
    this.depositIn.amount = isNaN(parsed) ? null : parsed;
    this.crunchData();
  }

  public onAmountBlur(): void {
    if (this.depositIn.amount === null || this.depositIn.amount === undefined) {
      return;
    }
    const usesComma = String(this.amountInput).includes(',');
    const fixed = Number(this.depositIn.amount).toFixed(2);
    this.amountInput = usesComma ? fixed.replace('.', ',') : fixed;
  }
}
